import { useLazyQuery  } from '@apollo/client';
import {SHIPPING_RATES} from "../shippingTypeDefs";

export const useQueryShippingRates = (options?: any): any => (
  useLazyQuery (SHIPPING_RATES, options)
);
